<template>
  <div class="home">
      <banner />
      <div class="home-top" style="margin-top: 20px;">
        <div class="home-top-posts">
          <ue-tabs :tabs="tabs" @loadPost="loadPost" />
          <div class="home-top-cards" v-if="postList && postList.posts && postList.posts.length > 0">
            <PostCard v-for="item in postList.posts.slice(0, 4)" :key="item._id" :post="item" />
          </div>
        </div>
        <div>
          <hot-author />
          <hot-articles style="margin-top: 30px" />
         </div>
      </div>
      <courser-banner />
      <div class="home-top"  v-if="postList && postList.posts && postList.posts.length > 4">
        <div class="home-top-posts">
          <div class="home-top-cards">
            <PostCard v-for="item in postList.posts.slice(4)" :key="item._id" :post="item" />
          </div>
        </div>
        <div>
          <hot-topic />
        </div>
      </div>
      <div style="width: 850px; margin-top: 41px;" v-if="!postList.isLastPage">
      <span class="ue-btn ue-btn-filling" style="width: 620px;" @click="loadMore">查看更多文章</span>
    </div>
  </div>
</template>
<script>
import Banner from '@/components/home/Banner.vue'
import UeTabs from '@/components/home/UeTabs.vue'
import PostCard from '@/components/post/PostCard'
import CourserBanner from '@/components/course/CourseBanner'
import BaseCard from '@/components/common/BaseCard.vue'
import HotArticles from '@/components/common/HotArticles.vue'
import HotAuthor from '@/components/common/HotAuthor'
import HotTopic from '@/components/common/HotTopic'
import { mapGetters, mapActions } from 'vuex'
export const articleTabs = [
  {
    id: "",
    name: '最新文章',
    enname: 'newProducts'
  },
  {
    id: "588471cc08ec05162c2e18d8",
    name: '竞品赏析',
    enname: 'competingProducts'
  },{
    name: '设计思考',
    id: "591e5fb0d82529145405981f",
    enname: 'design'
  },{
    name: '前沿报告',
    id: "592532cfb731fa19d4357919",
    enname: 'research'
  },{
    name: '实战案例',
    id: "5f58abc7e76d15d6a58e6103",
    enname: 'case'
  },{
    name: '体验沙龙',
    id: "5f58abdde76d15d6a58e6104",
    enname: 'experience'
  }
]
export default {
  name: 'home',
  data () {
    return {
      ca: '',
      tabs: articleTabs,
    }
  },
  components: {
    Banner, UeTabs, PostCard, CourserBanner, BaseCard, HotAuthor, HotTopic, HotArticles
  },
  computed: {
    ...mapGetters('post', ['postList'])
  },
  methods: {
    ...mapActions('post', ['getPostList']),
    loadPost (ca) {
      this.ca = ca
      this.getPostList({ca: ca});
    },
    loadMore () {
      if(!this.postList.isLastPage) {
        this.getPostList({ca: this.ca, p: parseInt(this.postList.page) + 1, loadMore: true});
      }
    }
  },
  created () {
  }
}
</script>
<style lang="scss" scoped>
.home {
  padding: 40px 0;
  >.home-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    >.home-top-posts {
        width: 850px;
        >.home-top-cards {
          >:not(:first-child) {
          border-top: 1px solid rgba(234,234,234,1);
        }
      }
    }
  }
  .card-title{
    font-size: 16px;
    font-weight:bold;
    color:rgba(51,51,51,1);
    text-align: left;
  }
}
</style>

